/**
 * Build values that differ per deploy or per environment, read from the
 * `<meta name="9brains-…">` tags that vite.config.ts writes into index.html.
 *
 * They deliberately do NOT go through `import.meta.env`: Vite inlines those
 * into whichever chunk reads them, that chunk gets a new content hash, and
 * every chunk importing it gets one too. A new build id alone renamed 205 of
 * the 723 bundle files, so each deploy shipped ~5 MB of unchanged code under
 * new names (re-downloaded by every user, piled up in the image's asset attic),
 * and staging and production never shared a single chunk. index.html is not
 * hashed and is served `no-cache`, so values living there leave the chunks
 * byte-identical between builds of the same code.
 */

export type HtmlConfigKey = 'build-id' | 'native-api-base-url' | 'turnstile-sitekey';

/** Meta tag name for a key; shared with vite.config.ts and the mobile bundle guards. */
export function htmlConfigMetaName(key: HtmlConfigKey): string {
  return `9brains-${key}`;
}

/** The value baked into index.html, or undefined when the build left it unset. */
export function htmlConfig(key: HtmlConfigKey): string | undefined {
  if (typeof document === 'undefined') return undefined;
  const meta = document.querySelector<HTMLMetaElement>(`meta[name="${htmlConfigMetaName(key)}"]`);
  return meta?.content || undefined;
}
